module.exports = __webpack_public_path__ + "img/philexport.eae5696d.png";